export const docIdToFriendlyName = {
    A_AMND: 'Auto Policy Amendatory Endorsement',
    A_APPL: 'Auto Application',
    A_APTA: 'Automobile Policy Term Acknowledgement Form',
    A_BIOF: 'Bodily Injury Option and Premiums',
    A_BISF: 'Choice of Bodily Injury Liability Coverage Limits',
    A_CNPY: 'Cancellation Notice',
    A_CNREL: 'Cancellation Notice',
    A_CNRET: 'Cancellation Notice',
    A_CNREV: 'Cancellation Notice',
    A_CNRS: 'Cancellation Notice',
    A_CODW: 'Collision Deductible Waiver',
    A_DRAT: 'Unverified Driver Attestation',
    A_DECK: 'Auto Declarations',
    A_DECLL: 'Declination Notice',
    A_DECLT2: 'Declination Notice',
    A_DECLT: 'Declination Notice',
    A_DECLV: 'Declination Notice',
    A_DITR: 'Declaration of Intent to Reside',
    A_ICSE: 'Insurance Consultation Services Exemption',
    A_IDCD: 'Auto ID Cards',
    A_MRMV: 'Massachusetts RMV Insurance Certification',
    A_INNO: 'Important Insurance Notice',
    A_LOIW: 'Loss of Income Waiver',
    A_MEDP: 'MedPay Selection/Rejection Form',
    A_MPSF: 'Selection of Personal Injury Protection',
    A_NDEL: 'Named Driver Exclusion Election Form',
    A_NDEX: 'Named Driver Exclusion',
    A_NNOP: 'Named Non-Owner Coverage Endorsement',
    A_IACH: 'Illinois Amendatory Endorsement - Consumer Hotline',
    A_NOBE: 'Notice of Benefits',
    A_NOTO: 'Notice of Tort Options',
    A_NPRCT: 'Rescission Notice',
    A_NRBIX: 'Insurance Cancellation Notice',
    A_NRRS: 'Non-Renewal Notice',
    A_NULL: 'Null Contract',
    A_PIPR: 'Pet Injury Endorsement',
    A_PIPS: 'Notice of Waiver of Personal Injury Protection',
    A_PJAK: 'Auto Policy',
    A_PLCY: 'Auto Policy',
    A_PSDS: 'Surcharge Disclosure',
    A_RENT: 'Renters Endorsement',
    A_RIDE: 'Rideshare Endorsement',
    A_SFSW: 'Auto Stress-Free Switch Letter',
    A_SMCQ: 'State Minimum Coverage Quote',
    A_TOSF: 'Tort Selection Rejection Form',
    A_UIMS: 'UIM Selection Rejection Form',
    A_POSF: 'Florida Selection of Personal Injury Protection',
    A_UMNF: 'Notice Regarding UMPD',
    A_UMRJ: 'UM Rejection Form',
    A_UIMR: 'UIM Rejection Form',
    A_UMSF: 'UM or UM/UIM Selection Rejection Form',
    A_WGPT: 'Window Glass Coverage Endorsement',
    A_WLBW: 'Work Loss Benefits Waiver',
    B_AUTH: 'Recurring Payment Authorization',
    B_SASP: 'Subscriber Agreement Signature Page',
    BRANCH_AUTO_ID_CARDS: 'Auto ID Cards',
    H_AAVK: 'Adverse Action Decision Notice',
    H_ACSF: 'Additional Coverage Offerings',
    H_AMND: 'Home Policy Amendatory Endorsement',
    H_ANME: 'Animal Liability Exclusion',
    H_ANML: 'Animal Liability Limitation Endorsement',
    H_APPL: 'Homeowners Application',
    H_BIND: 'Home Insurance Proof of Insurance',
    H_CMSL: 'Coal Mine Subsidence Waiver',
    H_CNPY: 'Cancellation Notice',
    H_CNRN: 'Insurance Cancellation Notice',
    H_CNRS: 'Cancellation Notice',
    H_DECK: 'Homeowners Declarations',
    H_DPUA: 'Homeowners Personal Umbrella Liability Declarations Addendum',
    H_EUSF: 'Excess UM/UIM Motorists Selection/Rejection Form',
    H_FCRA: 'Adverse Action Decision Notice',
    H_FLOX: 'Flood Notice',
    H_IB10: 'Increased Building Structure Protection 10% Endorsement',
    H_IB25: 'Increased Building Structure Protection 25% Endorsement',
    H_INVC: 'Escrow Invoice',
    H_LADN: 'Louisiana Deductible Notice',
    H_MINA: 'Mine Subsidence Insurance Underwriting Association Application',
    H_MINE: 'Mine Subsidence Endorsement',
    H_MNSF: 'Mine Subsidence Selection Rejection Form',
    H_NRBIX: 'Insurance Cancellation Notice',
    H_NRREV: 'Non-Renewal Notice',
    H_NRRS: 'Non-Renewal Notice',
    H_NULL: 'Null Contract',
    H_PJAK: 'Homeowners Policy',
    H_PLCY: 'Homeowners Policy',
    H_PUMB: 'Personal Umbrella Liability Endorsement',
    H_RCEL: 'Home Replacement Cost Estimate Letter',
    H_RENI: 'Fair Rental Income Endorsement',
    H_ROFE: 'Roof Surfaces Extended Coverage',
    H_ROFM: 'Metal Roof Surfaces Cosmetic Damage Exclusion',
    H_ROOF: 'Roof Surfaces Endorsement',
    H_SEWX: 'DC Sewer Notice',
    H_SFSW: 'Home Stress-Free Switch Letter',
    H_SHAR: 'Home Data Sharing Authorization',
    H_SPPE: 'Scheduled Personal Property ',
    H_WHXX: 'Wind/Hail Exclusion Form',
    H_WNHD: 'Windstorm and Hail Deductible Endorsement',
    H_WTBU: 'Water Backup Endorsement',
    R_AMND: 'Renters Policy Amendatory Endorsement',
    R_APPL: 'Renters Application',
    R_CNPY: 'Cancellation Notice',
    R_CNRS: 'Cancellation Notice',
    R_DECK: 'Renters Declarations',
    R_NRRS: 'Non-Renewal Notice',
    R_PJAK: 'Renters Policy',
    R_PLCY: 'Renters Policy',
    R_SFSW: 'Renters Stress-Free Switch Letter',
    C_APPL: 'Condo Application',
    C_MINA: 'Mine Subsidence Insurance Underwriting Association Application',
    C_DECK: 'Condo Declarations',
    C_PJAK: 'Condo Policy',
    C_WTBU: 'Water Backup Endorsement',
    C_DPUA: 'Condo Personal Umbrella Liability Declarations Addendum',
    C_PUMB: 'Personal Umbrella Liability Endorsement',
    R_SPPE: 'Scheduled Personal Property',
    C_SPPE: 'Scheduled Personal Property',
    C_INVC: 'Escrow Invoice',
    C_BIND: 'Condo Insurance Proof of Insurance',
    C_AMND: 'Condo Policy Amendatory Endorsement'
};
export const generateFriendlyName = (fileName) => {
    const docIdWithoutExt = fileName // '2019-2-14-19-29-A_IDCD.pdf'
        .split('.'); // [2019-2-14-19-29-A_IDCD, pdf']
    let docId = docIdWithoutExt[0]
        .split('-') // ['2019', '2', '14', '19', '29', 'A_IDCD']
        .slice(-1)[0] // ['A_IDCD']
        .toUpperCase(); // 'A_IDCD'
    // also drop out "BF_" if it starts with that.
    docId = docId.replace('BF_', '');
    // handle case where id has _CW and ends with stuff after _CW
    docId = !docId.includes('_CW_') ? docId : docId.split('_CW_')[0].concat('_CW');
    // strip off _XY if it ends that way
    docId = docId.match(/_[A-Z][A-Z]$/) ? docId.replace(/_[A-Z][A-Z]$/, '') : docId;
    return docIdToFriendlyName[docId] || fileName;
};
//# sourceMappingURL=index.js.map